import { MessageCircle, ArrowUpRight, Phone } from "lucide-react";
import { IMG, waLink, PHONE_DISPLAY } from "@/lib/site";
import { Reveal } from "@/lib/motion";

export const CTA = () => (
  <section className="relative py-16 bg-white">
    <div className="max-w-7xl mx-auto px-4 md:px-8">
      <Reveal>
        <div className="relative overflow-hidden rounded-[2rem] bg-[#012a60] px-8 py-14 sm:px-14 sm:py-20">
          <div className="grain" />
          <div
            className="absolute inset-0 opacity-20 bg-cover bg-center"
            style={{ backgroundImage: `url(${IMG.boxPreto})` }}
          />
          <div className="absolute inset-0 bg-gradient-to-r from-[#012a60] via-[#012a60]/90 to-[#012a60]/40" />
          <div className="absolute -top-24 -right-24 h-72 w-72 rounded-full bg-[#55c0e0]/25 blur-3xl" />

          <div className="relative max-w-2xl">
            <p className="text-sm font-bold uppercase tracking-[0.2em] text-[#55c0e0] mb-4">Gostou dos nossos trabalhos?</p>
            <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-white text-balance">
              Solicite seu orçamento agora mesmo
            </h2>
            <p className="mt-5 text-white/70 leading-relaxed max-w-lg">
              Orçamento sem compromisso, atendimento rápido e acabamento impecável. Fale com a nossa
              equipe pelo WhatsApp e transforme seu ambiente.
            </p>
            <div className="mt-9 flex flex-wrap items-center gap-4">
              <a href={waLink()} target="_blank" rel="noopener noreferrer" data-testid="cta-whatsapp-btn"
                className="group inline-flex items-center gap-2 rounded-full bg-[#25D366] px-7 py-4 font-bold text-white hover:opacity-90 transition-opacity">
                <MessageCircle size={18} /> Falar no WhatsApp
                <ArrowUpRight size={17} className="transition-transform group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
              </a>
              <a href={`tel:+5548996889862`}
                className="inline-flex items-center gap-2 rounded-full border border-white/25 px-7 py-4 font-bold text-white hover:bg-white/10 transition-colors">
                <Phone size={17} className="text-[#55c0e0]" /> {PHONE_DISPLAY}
              </a>
            </div>
          </div>
        </div>
      </Reveal>
    </div>
  </section>
);
